import { render, staticRenderFns } from "./GeneralParameters.vue?vue&type=template&id=31c7dcdc&scoped=true"
import script from "./GeneralParameters.vue?vue&type=script&lang=js"
export * from "./GeneralParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c7dcdc",
  null
  
)

export default component.exports